export default __webpack_public_path__ + "static/media/left-desktop-header-bg.bf95a6e7.svg";